import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import toast from '@/plugins/toast'
import VueDragscroll from 'vue-dragscroll'

import sharedConstants from '@/plugins/shared-constants'
import validationRules from './plugins/validation-rules'
import '@/plugins/stripe'

import '@/filters'
import '@babel/polyfill'
import 'es6-promise/auto'

// import any styles here
import '@/scss/app.scss'
import '@/scss/fonts.scss'
import '@/scss/field-styles.scss'

// global component import go here
import AppTextField from '@/components/AppTextField.vue'
import AppPageTitle from '@/components/AppPageTitle.vue'
import AppButton from '@/components/AppButton.vue'
import AppDialog from '@/components/AppDialog.vue'
import Layout from '@/components/Layout/Layout.vue'
import PlainLayout from '@/components/Layout/PlainLayout.vue'
import BottomBar from '@/components/BottomBar.vue'

Vue.component('app-text-field', AppTextField)
Vue.component('app-page-title', AppPageTitle)
Vue.component('app-button', AppButton)
Vue.component('app-dialog', AppDialog)
Vue.component('layout', Layout)
Vue.component('plain-layout', PlainLayout)
Vue.component('bottom-bar', BottomBar)

Vue.config.productionTip = false

Vue.use(sharedConstants)
Vue.use(validationRules)
Vue.use(VueDragscroll)

window.OneSignal = window.OneSignal || []

new Vue({
  router,
  store,
  i18n,
  toast,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
